"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = exports.cardWidthDesktop = exports.cardWidthMobile = exports.cardHeight = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
exports.cardHeight = 171;
exports.cardWidthMobile = 149;
exports.cardWidthDesktop = 201;
var Component = function (p) { return (Preact.h(Box_1.default, { sx: {
        backgroundColor: 'background.default',
        p: '12px',
        borderRadius: '8px',
        gap: '12px',
        alignItems: 'center',
        width: { xs: exports.cardWidthMobile, md: exports.cardWidthDesktop },
        height: exports.cardHeight,
        boxSizing: 'border-box',
        display: 'grid',
        gridTemplateRows: '70px 1fr',
        flexShrink: '0',
    } },
    !p.disabled ? (Preact.h(Preact.Fragment, null, p.content ? (Preact.h("img", { style: { width: '100%', height: '100%', objectFit: 'contain' }, src: p.content })) : (Preact.h(Box_1.default, null)))) : (Preact.h(Box_1.default, null)),
    Preact.h(Box_1.default, { width: "100%", overflow: "hidden" },
        Preact.h(Typography_1.default, { width: "100%", textAlign: "center", variant: "h6", color: p.disabled ? 'text.disabled' : 'secondary', noWrap: true }, p.question),
        Preact.h(Box_1.default, { display: "flex", justifyContent: "center", alignItems: "center", height: "36px" },
            Preact.h(Typography_1.default, { width: "100%", textAlign: "center", variant: "body1", color: p.disabled ? 'text.disabled' : 'secondary', noWrap: true }, p.currentOptionText === null ? p.nullOptionText : p.currentOptionText))))); };
exports.Component = Component;
